import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/mn';

dayjs.locale('mn', {
  relativeTime: {
    future: '%s дараа',
    past: '%s өмнө',
    s: '1 минутын',
    m: '1 минутын',
    mm: '%d минутын',
    h: '1 цагийн',
    hh: '%d цагийн',
    d: '1 өдрийн',
    dd: '%d өдрийн',
    M: '1 сарын',
    MM: '%d сарын',
    y: '1 жилийн',
    yy: '%d жилийн',
  },
});

dayjs.extend(relativeTime);

const dayJS = {
  unix: (timestamp: number) => dayjs.unix(timestamp),
  fromNow: (date?: string | Date) => dayjs(date).fromNow(),
  to: (date: string | Date) => dayjs().to(dayjs(date)),
};

export default dayJS;
